<div class="col-12 d-flex justify-content-between align-items-center">
  <div class="form-field col-7">
    <p-floatlabel variant="on" class=" w-100">
      <input
        id="otpCode"
        pInputText
        [(ngModel)]="otp"
        [ngModelOptions]="{standalone: true}"
        name="otpCode"
        class="w-100"
        type="text" data-testid="otp-code-input">
      <label for="otpCode" class="label">{{'auth.validationCode' | translate}}</label>
    </p-floatlabel>
  </div>

  <div class="col-4">
    <button type="button" pButton [label]="'auth.validateCode' | translate" class="p-button w-100"
            (click)="validateCode()" data-testid="validate-code-btn"></button>
  </div>
</div>

<div class="mt-3 col-12">
  <button type="button" pButton [label]="'auth.sendSmsValidation' | translate" class="p-button-outlined w-100"
          (click)="sendValidationSMS(userUuid)" data-testid="send-sms-validation-btn"></button>
</div>
